import { VsfContext } from "~/composables/context";
import { Logger } from "~/helpers/logger";
import { Cart, CartItemInput, RemoveItemFromCartInput } from "~/modules/GraphQL/types";
import { CustomQuery, CustomHeaders } from "~/types/core";

/** Params object used to add items to a cart */
export declare type AddProductsToCartInput = {
  cartId: string;
  cartItems: CartItemInput[];
};

export const updateItemCommand = {
  execute: async (context: VsfContext, { skuNew, uidRemove, currentCart, quantity, customQuery, customHeaders }) => {
    const apiState = context.$magento.config.state;
    const cartId = apiState.getCartId();
    if (!skuNew || !uidRemove) {
      return;
    }
    // eslint-disable-next-line no-underscore-dangle
    const variableAddItemCart: AddProductsToCartInput = {
      cartId,
      cartItems: [
        {
          quantity,
          sku: skuNew,
        },
      ],
    };

    const itemAddToCart = await context.$magento.api.addProductsToCart(
      variableAddItemCart,
      customQuery as CustomQuery,
      customHeaders as CustomHeaders
    );
    Logger.debug("[Result itemAddToCart]:", { data: itemAddToCart.data });

    if (itemAddToCart.data.addProductsToCart.user_errors.length > 0) {
      throw new Error(String(itemAddToCart.data.addProductsToCart.user_errors[0].message));
    }

    const item = currentCart.items.find((cartItem) => cartItem.uid === uidRemove);

    if (!item) {
      return;
    }

    const removeItemParams: RemoveItemFromCartInput = {
      cart_id: currentCart.id,
      cart_item_uid: item.uid,
    };

    const { data } = await context.$magento.api.removeItemFromCart(removeItemParams, customQuery as CustomQuery, customHeaders as CustomHeaders);

    return data.removeItemFromCart.cart as unknown as Cart;
  },
};
